export default {
	API_ENDPOINT: 'https://peaceful-reaches-62779.herokuapp.com',
	TOKEN_KEY: 'photoGram-client-auth-token',
	CLOUDINARY_NAME: 'rcarville',
	CLOUDINARY_URL:
		'cloudinary://521896384739584:ONPrERxnkLcedTdtBTlcoZeDWwE@rcarville',
	CLOUDINARY_API: 'https://api.cloudinary.com/v1_1/rcarville/image/upload',
	CLOUDINARY_API_KEY: '521896384739584',
	CLOUDINARY_API_SECRET: 'ONPrERxnkLcedTdtBTlcoZeDWwE',
	CLOUDINARY_PROFILE_UPLOAD_PRESET: 'photoGram_profileImage',
	CLOUDINARY_UPLOAD_PRESET: 'photoGram_Images',
	CLOUDINARY_ALBUM_IMAGES_PRESET: 'photoGram_Album_Images'
};
//https://peaceful-reaches-62779.herokuapp.com
